import React, {useState, useEffect} from 'react';
import {duckify, filterDuck, singleDuck} from 'utils/duckify';
import {
  checklistAnswers,
} from 'ducks';
import {connect} from "react-redux";
import ModalComponent from "components/ModalComponent";
import {Button} from "react-bootstrap";
import FontAwesome from '../../utils/FA';

const BasicChecklistCompletionModal = ({dispatch, checklistAnswerId}) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState();

  const submit = () => {
    setSubmitting(true);

    dispatch(
      checklistAnswers.actions.completeBasic(checklistAnswerId)
    )
      .then(() => window.location.reload())
      .catch(({error}) => {
        setSubmitting(false);
        setError(error);
      });
    ;
  };

  return <ModalComponent
    title='Complete Checklist Item'
    buttons={[
      <Button
        className={'btn btn-success'}
        disabled={submitting}
        onClick={() => submit(dispatch, checklistAnswerId)}
      >
        {submitting && <FontAwesome name={'spinner'} spin nbsp/>}
        Submit
      </Button>
    ]}
    className={'basic-checklist-item-completion'}
  >
    Are you sure you would like to complete this checklist item?

    {error &&
      <div className={'alert alert-danger'}>
        We were unable to complete this checklist item.  {error}
      </div>
    }
  </ModalComponent>;
}

export default connect()(BasicChecklistCompletionModal);
